import { InputLabel, MenuItem, SelectChangeEvent } from '@mui/material';
import { AxiosResponse } from 'axios';
import { memo } from 'react';
import { PmiSelect } from 'shell/components/shared/pmi-select';
import { PmiFormControl } from 'shell/components/shared/pmi-select/pmi-form-control';
import { __PRACTICE_API_URL__ } from 'shell/constants/environment';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';
import { HttpResponseList } from 'shell/models/http-response';
import { TypeRegisterData } from 'shell/models/practice-lists';
import { ItemVM } from 'shell/view-models/item';

interface ListTypeRegisterProps {
  disabled?: boolean;
  required?: boolean;
  value: string;
  onChange: (event: SelectChangeEvent<string>) => void;
  error?: boolean;
}

const ListTypeRegisterComponent = ({
  disabled,
  required,
  onChange,
  value,
  error,
}: ListTypeRegisterProps): React.ReactElement => {
  const [list] = useHttpFetch<HttpResponseList<TypeRegisterData>, Array<ItemVM>>(
    `${__PRACTICE_API_URL__}/pratiche/tipo-registro`,
    {
      onBootstrap: true,
      options: {
        errorCatching: true,
        method: 'GET',
        loading: true,
        params: {
          sort: 'descrizioneRegistro:ASC',
        },
      },
      transformer: (response: AxiosResponse<HttpResponseList<TypeRegisterData>>) => {
        const { data } = response;
        return data?.payload.list?.map((item) => ({
          id: item.key?.tipoRegistro || '',
          value: item.descrizioneRegistro || '',
        }));
      },
    }
  );

  const dataList = (list.data as Array<ItemVM>) || [];

  return (
    <PmiFormControl fullWidth>
      <InputLabel error={error} id="type-label">
        {required ? 'Tipologia di registro *' : 'Tipologia di registro'}
      </InputLabel>
      <PmiSelect
        labelId="type-label"
        id="type-Register"
        name="type-Register"
        value={value}
        label={required ? 'Tipologia di registro *' : 'Tipologia di registro'}
        onChange={onChange}
        disabled={disabled}
        error={error}
      >
        <MenuItem value="">
          <em>Nessuno</em>
        </MenuItem>
        {dataList?.map((type: ItemVM) => (
          <MenuItem key={type.id} value={type.id}>
            {type.value}
          </MenuItem>
        ))}
      </PmiSelect>
    </PmiFormControl>
  );
};

ListTypeRegisterComponent.displayName = 'List type component';

const ListTypeRegister = memo(ListTypeRegisterComponent);

export default ListTypeRegister as typeof ListTypeRegisterComponent;
